import { render, staticRenderFns } from "./MarketOrder.vue?vue&type=template&id=5a9c226c&scoped=true"
import script from "./MarketOrder.vue?vue&type=script&lang=js"
export * from "./MarketOrder.vue?vue&type=script&lang=js"
import style0 from "./MarketOrder.vue?vue&type=style&index=0&id=5a9c226c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9c226c",
  null
  
)

export default component.exports